$.fn.Timer = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _startTimers = $('.start-timer'),
        _interval = '',
        _timer = $('#header .project-timer h4 .timer');

    // custom variables
    var o = $.extend({

    }, options);


    _this.init = function() {
        // start timer
        _startTimers.dropdown('setting', 'onChange', function(value, text) {
            var projectId = $(this).data('project-id');
            _this.startTimer(value, text, projectId);
        });

        // stop timer
        $(document).on('click', '.stop-timer', function() {
            _this.stopTimer();
        });

        // run timer if on page load timer already shown
        if (_timer.length > 0)
            _this.runTimer();
    };

    _this.stopTimer = function() {
        var projectName = _timer.data('project-name');
        var subject     = _timer.data('subject');

        $('#stop-timer-modal .header').html(projectName + ' - ' + subject);

        $('#stop-timer-modal').modal({
            onShow: function() {
                /*
                    Hack for bad positioning
                 */
                setTimeout(function () {
                    $('#stop-timer-modal').modal('refresh');
                }, 1);

                // create ckeditor if hasnt created yet
                if ($('.cke_editor_project_description').length === 0)
                {
                    CKEDITOR.replace('project_description');
                    CKEDITOR.on('instanceReady', function() {
                        $('#stop-timer-modal').modal('refresh');
                    });
                }
            },
            onApprove: function() {
                var ckeditorHTML = CKEDITOR.instances.project_description.getData();

                $.ajax('/_cms/crm/view/0/projects/', { data: {ajax: 1, stopTimer: 1, description: ckeditorHTML},
                    type: 'POST',
                    error: function(data) {
                        console.log(data);
                    },
                    success: function(data) {
                        var response = jQuery.parseJSON(data);

                        if (response.status == 'success')
                        {
                            _startTimers.addClass('disabled');

                            var projectTimer = $('#header .project-timer');

                            // clear ckeditor values
                            CKEDITOR.instances.project_description.setData('');

                            // hide timer
                            projectTimer.fadeOut(600, function() {
                                projectTimer.html('');
                                clearInterval(_interval);
                                _startTimers.removeClass('disabled');
                            });

                            new Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'success',
                                showCloseButton: true
                            });
                        }
                        else if (response.status == 'failed')
                        {
                            new Messenger().post({
                                message: response.message,
                                hideAfter: 3.5,
                                type: 'error',
                                showCloseButton: true
                            });
                        }
                    }
                });
            }
        }).modal('show');
    };

    _this.runTimer = function() {
        _timer = $('#header .project-timer h4 .timer');

        var seconds     = _timer.data('seconds');
        var minutes     = _timer.data('minutes');
        var hours       = _timer.data('hours');

        _interval = setInterval(function() {
            seconds++;

            if (seconds > 59)
            {
                seconds = 0;
                minutes++;
            }

            if (minutes > 59)
            {
                minutes = 0;
                hours++;
            }

            // leading zeros
            if (seconds.toString().length == 1)
                seconds = '0' + seconds;

            if (minutes.toString().length == 1)
                minutes = '0' + minutes;

            if (hours.toString().length == 1)
                hours = '0' + hours;

            _timer.html(hours + ':' + minutes + ':' + seconds);
        }, 1000);
    };

    _this.startTimer = function(value, text, projectId) {
        $.ajax('', { data: {ajax: 1, value: value, text: text, projectId: projectId},
            type: 'POST',
            error: function(data) {
                console.log(data);
            },
            success: function(data) {
                var response = jQuery.parseJSON(data);

                if (response.status == 'success')
                {
                    _startTimers.addClass('disabled');

                    var projectTimer = $('#header .project-timer');

                    // show timer
                    projectTimer.hide()
                    .prepend('<h4>'+ response.projectName +' - <span class="timer" data-project-name="'+ response.projectName +'" data-subject="'+ text +'" data-hours="00" data-minutes="00" data-seconds="00">00:00:00</span></h4>')
                    .append('<button class="stop-timer btn btn-red" title="Stop timer"><i class="fa fa-stop-circle-o"></i></button>')
                    .fadeIn(600);

                    _this.runTimer();

                    new Messenger().post({
                        message: response.message,
                        hideAfter: 3.5,
                        type: 'success',
                        showCloseButton: true
                    });
                }
                else if (response.status == 'failed')
                {
                    new Messenger().post({
                        message: response.message,
                        hideAfter: 3.5,
                        type: 'error',
                        showCloseButton: true
                    });
                }
            }
        });
    };

    _this.init();
};